import React, { useState, createRef } from 'react'
import PermissionsCmp from './Permissions'
import Employees from '../../../../api/Employees'
import { strVal } from '../../../../modules/Utils'
import { withRouter } from 'react-router-dom'
import { message } from 'antd'
import { isEmpty, omit, pick } from 'lodash'

const api = new Employees()

function Permissions(props) {
  const owner = props.match.url
  const key = props.owner || props.match.params.key
  console.log('props.owner', props.owner)

  const [loading, setLoading] = useState(false)
  const [updating, setUpdating] = useState(false)
  const [state, setState] = useState({
    read: { indeterminate: false, column: false },
    write: { indeterminate: false, column: false },
    stamp: { indeterminate: false, column: false },
    menu: { indeterminate: false, column: false },
  })
  // const [loading, setLoading] = useState(false)

  // this.companyID = ''
  // this.state = {
  //   data: [],
  //   loading: false,
  //   updating: false,
  //   corporates: [],
  //   read: { indeterminate: false, column: false },
  //   write: { indeterminate: false, column: false },
  //   stamp: { indeterminate: false, column: false },
  //   menu: { indeterminate: false, column: false },
  // }

  const formRef = createRef()

  const fetch = async (company) => {
    if (!isEmpty(company))
      try {
        const companyID = company.replace('members/', '')
        setLoading(true)
        const response = await api.permissions.list(key.replace('members/', ''), companyID)
        let data = await response.json()
        const read = getColumnStatus('read', data)
        const write = getColumnStatus('write', data)
        const stamp = getColumnStatus('stamp', data)
        const menu = getColumnStatus('menu', data)
        setState((e) => ({ ...e, data, read, write, stamp, menu, company, companyID }))
        setLoading(false)
      } catch (error) {
        console.log(error)
        message.error(JSON.stringify(error))
        setLoading(false)
      }
  }

  const submit = async () => {
    try {
      setUpdating(true)
      const values = state.data.map((v) => {
        v.department = strVal(v, 'department')
        if (v.department === '') v = omit(v, 'department')
        return v
      })
      await api.permissions.update(key.replace('members/', ''), state.companyID, values)
      message.success('Updated')
      setUpdating(false)
    } catch (error) {
      message.error(error.errorMessage)
      setUpdating(false)
    }
  }

  const onColumnChange = (e, key) => {
    const data = [...state.data]
    data.forEach((item) => {
      item[key] = e.target.checked
    })
    setState((p) => ({
      ...p,
      data,
      [key]: {
        column: e.target.checked,
        indeterminate: false,
      },
    }))
  }
  const onCellChange = (e, rule, key) => {
    const data = [...state.data]
    const target = data.find((item) => item.rule === rule)
    if (target) {
      target[key] = e.target.checked
      const status = getColumnStatus(key, data)
      setState((p) => ({
        ...p,
        data,
        [key]: status,
      }))
    }
  }

  const getColumnStatus = (rule, data) => {
    const checked = data.filter((d) => d[rule] === true).length
    return {
      indeterminate: checked > 0 && checked < data.length,
      column: checked > 0,
    }
  }

  return (
    <PermissionsCmp
      ref={formRef}
      {...{
        submit,
        fetch,
        onColumnChange,
        onCellChange,
        ...state,
      }}
    />
  )
}

export default withRouter(Permissions)
